export const getBearerToken = () => {
  // Keep this import lazy to avoid a cycle while the Redux store is created.
  // eslint-disable-next-line global-require
  const token = require('store/store').store.getState().userDetails?.authToken;

  return token ? `Bearer ${token}` : '';
};

export const getLocalToken = () => {
  const token = localStorage.getItem('token');

  return token ? `Token ${token}` : '';
};
